import useCampaignManagementStore from "@/store/campaignManagement";
import {locationAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import {useEffect} from "react";
import {useLocation} from "react-router";

const useLocationEffect = () => {
  const [value, setValue] = useAtom(locationAtom);
  const location = useLocation();
  const resetCampaignStore = useCampaignManagementStore(state => state.reset);

  useEffect(() => {
    setValue({
      previousRoute: value.currentRoute,
      currentRoute: location?.pathname ?? "",
    });
    resetCampaignStore();
  }, [location.pathname, resetCampaignStore, setValue]);
};

export default useLocationEffect;
